import React from "react"
import PropTypes from "prop-types"
import PartenaireItem from "../PartenaireItem/partenaire-item"

const RenderPartenaires = ({ partenairesData }) => {
  return partenairesData.allDirectLinkEntityDirectLinkEntity.edges.map(
    ({ node }) => {
      return <PartenaireItem key={node.drupal_id} partenaire={node} />
    }
  )
}

RenderPartenaires.propTypes = {
  partenairesData: PropTypes.object.isRequired,
}

export default RenderPartenaires
